export default "<div>\n  <p>{{ displayName }}</p>\n  <div (click)=\"invokeEdit()\">\n    <mat-icon>edit</mat-icon>\n    <span>Edit</span>\n  </div>\n</div>\n";